import * as TabsPrimitive from "@radix-ui/react-tabs";
import { type ComponentPropsWithoutRef, type ElementRef, forwardRef } from "react";
import { cn } from "../../lib/utils";

export const PageTabsTrigger = forwardRef<
  ElementRef<typeof TabsPrimitive.Trigger>,
  ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      "relative inline-flex items-center justify-center whitespace-nowrap px-3 h-full text-sm font-normal transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:text-foreground z-10 before:content-[''] before:absolute before:inset-x-0 before:h-8 before:top-1/2 before:-translate-y-1/2 before:rounded-[10px] before:transition-colors before:duration-200 before:-z-10 hover:before:bg-muted after:content-[''] after:absolute after:left-0 after:right-0 after:h-1 after:bottom-0 after:top-auto after:rounded-full after:transition-colors after:duration-200 after:ease-in-out after:bg-transparent data-[state=active]:after:bg-foreground after:z-0",
      className
    )}
    {...props}
  />
));
PageTabsTrigger.displayName = TabsPrimitive.Trigger.displayName;
